module.exports = __webpack_public_path__ + "static/media/102.c033c367.png";